import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const GifContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  height: '250px',
  overflow: 'hidden',
  backgroundColor: theme.palette.mode === 'dark' ? '#1a1a1a' : '#f5f5f5',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(2),
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: theme.palette.mode === 'dark' 
      ? 'linear-gradient(180deg, rgba(30, 30, 30, 0.8) 0%, rgba(15, 15, 15, 0.95) 100%)'
      : 'linear-gradient(180deg, rgba(245, 245, 245, 0.8) 0%, rgba(250, 250, 250, 0.95) 100%)',
    zIndex: 0
  }
}));

const StyledImage = styled('img')({
  width: '100%',
  height: '100%',
  objectFit: 'contain',
  objectPosition: 'center',
  transition: 'transform 0.6s ease',
  position: 'relative',
  zIndex: 1,
  borderRadius: '8px',
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)'
});

const ProjectGifPlayer = ({ gifUrl, title }) => {
  return (
    <GifContainer>
      <StyledImage
        src={gifUrl}
        alt={title}
      />
    </GifContainer>
  );
};

export default ProjectGifPlayer; 